import { useTranslation } from 'react-i18next'
import {
  IconStatusExclamationTriangleColor,
  RouterLink,
  Text,
} from '@/components'
import CenteredPageTemplate from '@/components/layout/page-templates/CenteredPageTemplate'
import { substituteLocale } from '@/localization/utils'
import testLabels from './InvalidLinkError.labels'

const InvalidLinkError = () => {
  const { i18n, t } = useTranslation()

  return (
    <CenteredPageTemplate
      button={{
        component: (
          <RouterLink
            data-label={testLabels.errorInvalidLinkButton}
            replace
            to={substituteLocale(
              myESET.envData.ContactSupportURL,
              i18n.language
            )}
          >
            {t('InvalidLinkErrorButton')}
          </RouterLink>
        ),
      }}
      icon={
        <IconStatusExclamationTriangleColor display="inline-block" size={84} />
      }
      size="small"
      title={t('invalidLinkErrorTitle')}
    >
      <Text>{t('invalidLinkErrorDescription')}</Text>
    </CenteredPageTemplate>
  )
}

export default InvalidLinkError
